import Constants from "../constants/Constansts";
import { ChatMode } from "../enums/ChatMode";
import { MessageType } from "../enums/MessageType";
import BotStartMessage from "../models/BotStartMessage";
import IMessage from "../models/IMessage";

export default class BotStartMessageMapper {


    static mapToIMessageFromBotStartMessage(botMessage: BotStartMessage,chat_mode:ChatMode): IMessage {
        return {
            parent_message_id: "WelcomeMessage",
            message_id: "",
            conversation_id: "",
            content: botMessage.Message,
            author: "wtw ai",
            isUser: false,
            showDate: true,
            datetime: new Date().toISOString(),
            citations: [],
            messageType: MessageType.Welcome,
            timezone: Constants.TIMEZONE,
            timezone_offset: Constants.TIMEZONE_OFFSET,
            timestamp: new Date().toISOString(),
            chat_mode:chat_mode
        };
    }

}
